import React, {useEffect} from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import {Link, withRouter, WithRouterProps} from 'react-router';
import styled from 'styled-components';

import {
  cats,
  useKeyboardShortcuts,
} from 'app/general/shortcuts/useKeyboardShortcuts';
import {gt} from 'app/utils/i18n';

import {MoreMenu} from './MoreMenu';
import {isNavLinkActive, useNavLinks} from './nav_links';

export const NavigationTabs = withRouter(function NavigationTabs({
  router,
  routes,
}: WithRouterProps) {
  const {registerAndEnableShortcuts} = useKeyboardShortcuts();
  const links = useNavLinks('main');

  useEffect(() => {
    // usually we register the shortcuts when the file is scaned/executed
    // but here we need first get user custom links then register them in order
    registerAndEnableShortcuts(
      links.map((link, index) => ({
        // assign numbers shortcuts to each navigation link starting from 1
        key: (index + 1).toString(),
        name: () => gt('Go to %s page', link.title),
        category: cats.everywhere,
        callback: () => router.push(link.href),
      }))
    );
  }, [links]);

  return (
    <StyledNavigationListUl
      className="navbar-nav d-none d-lg-flex"
      role="navigation"
    >
      {links.map((link) => (
        <li
          key={link.slug}
          className={`nav-item justify-content-center d-flex align-items-stretch ${link.slug}`}
        >
          <Link
            className={`nav-link ${
              isNavLinkActive(link.slug, routes) ? 'active' : ''
            }`}
            to={link.href}
          >
            <span className="outer">
              <span className="inner">{link.title}</span>
            </span>
          </Link>
        </li>
      ))}
      <li className="nav-item justify-content-center d-flex align-items-stretch">
        <MoreMenu router={router} />
      </li>
    </StyledNavigationListUl>
  );
});

const StyledNavigationListUl = styled.ul`
  flex-grow: 1;

  > li {
    flex-grow: 1;
    max-width: 130px;

    .nav-link {
      padding: 0 1.25rem !important;
      color: #fff;
      display: flex;
      align-items: stretch;

      > .outer {
        display: flex;
        align-items: center;
        border-bottom: 0px solid ${colors.lightLinkBlue};
      }

      &:hover {
        color: ${colors.lightLinkBlue};
      }

      &.active {
        //background: ${colors.darkGreen};
        > .outer {
          border-bottom-width: 4px;
        }
      }
    }
  }
`;
